import { useCallback } from 'react';
import { useSelector } from 'react-redux';

import type { TFsmEvent } from '@/modules/onboarding/fsm-types';
import { getPartner } from '@/modules/partner/store/selectors';
import type { IFormProps } from '@/pages/Wizard/view-types';
import { eventTracking } from '@/services/event-tracking';
import { useForm } from '@/shared/view/Form';

import { Form, FormShape } from './Form';
import { useVehicleByClassList } from './hooks/useVehicleByClassList';

const VehicleSelection = ({ onSwitchScreen }: IFormProps<TFsmEvent>) => {
  const partner = useSelector(getPartner);
  const options = useVehicleByClassList(partner.cityName);

  const postForm = useCallback(
    async (formValues: FormShape) => {
      onSwitchScreen('NEXT');

      eventTracking.track({
        event:
          formValues.vehicle === 'None'
            ? 'Onboarding - Vehicle - Failed'
            : 'Onboarding - Vehicle - Success',
        type: formValues.vehicle,
      });

      return {};
    },
    [onSwitchScreen],
  );

  const {
    handleSubmit,
    form: { control, formState },
  } = useForm<FormShape>({
    preSaveStore: {
      storeId: `vehicleStepForm-${partner.id}`,
      type: 'memory',
    },
    onSubmit: postForm,
  });

  return (
    <Form
      items={options}
      control={control}
      onSubmit={handleSubmit}
      isSubmitting={formState.isSubmitting}
      isValid={formState.isValid}
    />
  );
};

export { VehicleSelection };
